import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isAndroid, isIOS } from 'react-device-detect';
import imgSource from 'resources/email-configmed@1x.png';
import { Col, Row } from '@guestyci/foundation/esm/Layout';
import TextField from '@guestyci/foundation/TextField';
import createStyles from '@guestyci/foundation/esm/createStyles/createStyles';
import _extends from '@babel/runtime/helpers/esm/extends';
import selectAppState from 'app/store/selector';
import MarketingLoginButton from 'app/components/MarketingLoginButton';
import tracker from 'app/utils/dio';
import theme from '@guestyci/foundation/theme/defaultTheme';
import AppStyle, { mediaScreen } from 'app/Styles';
import useQueryParams from 'app/hooks/useQueryParams';
import classNames from 'classnames';

const useStyles = createStyles(() =>
  _extends(AppStyle, {
    root: {
      maxWidth: theme.breakpoints.values.sm,
      margin: '0 auto',
      [mediaScreen.md]: {
        maxWidth: '100%',
      },
    },
    confirmedImg: {
      maxHeight: '28vh',
    },
    congratulationText: {
      fontSize: 'min(3rem, 4.5vh)',
    },
  }));

const ThankYouContentPage = () => {
  const classes = useStyles();
  const state = useSelector(selectAppState);
  const smartLink = useQueryParams();

  const SUCCESS_LINK = state.link || smartLink.get('smartlink');

  useEffect(() => {
    try {
      window.gtag?.(
        // CLUB-711
        'event',
        'conversion',
        { send_to: 'AW-710463040/ozbWCPz1540YEMCc49IC' }
      );

      // TikTok's analytics. Source is loaded in GTM-MHR76W2
      window.ttq.load('C95D8J3C77U5QKC672RG');
      window.ttq.page();
      window.ttq.instance('C95D8J3C77U5QKC672RG').track('Contact');
    } catch (e) {
      console.error(e);
    }
  }, []);

  const handleClickMarketing = useCallback(() => {
    if (isAndroid) tracker.clickDownloadAndroid();
    else if (isIOS) tracker.clickDownloadIos();
    else tracker.completePageClickLogin(state.isGoogleSignUp);

    try {
      window.fbq('trackCustom', 'ActivateAccountGhosts', {
        Registration: 'ActivateAccountGhosts',
      });
    } catch (e) {
      console.error('fbq event failed');
    }
  }, [state.isGoogleSignUp]);

  return (
    <div className={classes.root} id="thank-you-content-container">
      <Col span={12} spacing={10} align="center">
        <Row justify="between">
          <TextField
            align="center"
            className={classNames(classes.pageHeading, classes.congratulationText)}
          >
            {state.isGoogleSignUp
              ? 'All set! Your account is ready to use.'
              : 'Wonderful! Your email has been verified.'}
          </TextField>
        </Row>

        <Col span={7}>
          <img
            src={imgSource}
            id="account-confirmed-image"
            alt="Account Confirmed"
            className={classes.confirmedImg}
          />
        </Col>

        <MarketingLoginButton
          eventCallBack={handleClickMarketing}
          successLink={SUCCESS_LINK}
          className="activate-account-button text-uppercase"
        >
          Start Now
        </MarketingLoginButton>
        <img
          src="https://ct.capterra.com/capterra_tracker.gif?vid=2117898&vkey=8435a743baf32023648601e65a26c0c4"
          alt="Capterra Tracker"
        />
      </Col>
    </div>
  );
};

export default ThankYouContentPage;
